import React, { createContext, ReactNode, useContext } from 'react'
import {
  ElectronUpdaterHookResult,
  useElectronUpdater,
} from '~/hooks/useElectronUpdater'

const defaultUpdaterContextValue: ElectronUpdaterHookResult = {
  statusMessage: '',
  isUpdateAvailable: false,
  isUpdateDownloaded: false,
  isChecking: false,
  error: null,
  availableVersion: null,
  checkForUpdates: () => {
    console.warn('checkForUpdates called outside ElectronUpdaterProvider')
  },
  quitAndInstall: () => {
    console.warn('quitAndInstall called outside ElectronUpdaterProvider')
  },
}

const ElectronUpdaterContext = createContext<ElectronUpdaterHookResult>(
  defaultUpdaterContextValue,
)

interface ElectronUpdaterProviderProps {
  children: ReactNode
}

const THREE_HOURS_MS = 3 * 60 * 60 * 1000 // 10,800,000 ms

export const ElectronUpdaterProvider: React.FC<
  ElectronUpdaterProviderProps
> = ({ children }) => {
  const updaterState = useElectronUpdater(THREE_HOURS_MS)

  return (
    <ElectronUpdaterContext.Provider value={updaterState}>
      {children}
    </ElectronUpdaterContext.Provider>
  )
}

export const useElectronUpdaterContext = (): ElectronUpdaterHookResult => {
  const context = useContext(ElectronUpdaterContext)
  if (context === defaultUpdaterContextValue) {
    // This error check is helpful during development
    // It ensures you haven't forgotten to wrap your component tree
    throw new Error(
      'useElectronUpdaterContext must be used within an ElectronUpdaterProvider',
    )
    // Alternatively, you could return the default value, but throwing an error
    // is often better for catching setup mistakes.
  }
  return context
}
